export const lp: any = {
  searchFlightByDestinationTitle: "Flight Destinations in {{destination}}",
  flightReferencePriceListTitle: "Popular flights to {{destination}}",
  destinationAbout: "About {{destination}}",
  destinationBestSeason: "Best season for {{destination}}",
  conciergeComment: "Concierge comments",
  destinationMainAirlines: "Main airlines to {{destination}}",
  accessToCity: "Access to the city",
  searchHotelByDestinationTitle: "Search hotels in{{destination}}",
  hotelRecommendedListTitle: "Recommended hotels in {{destination}}",
  surroundingRegions: "Surrounding regions",
  orderExamples: "Order Examples",
  referencePrice: "Reference Price",
  cruiseSaleListTitle: "Cruises on Sale",
  cruiseRegionCruiseListTitle: "Cruises to {{name}}",
  cruiseRegionFaqTitle: "{{name}} FAQs",
  cruiseRegionIntroductionTitle: "About {{name}}",
  vesselCruiseListTitle: "Cruises on the {{name}}",
  vesselCabinListTitle: "{{name}} cabins",
  vesselAttractionListTitle: "{{name}} attractions",
  vesselFaqTitle: "{{name}} FAQs",
  vesselIntroductionTitle: "About {{name}}",
  vesselInfoTitle: "{{name}} overview",
  vesselBrandVesselListTitle: "{{name}} vessels",
  vesselBrandFaqTitle: "{{name}} FAQs",
  vesselBrandIntroductionTitle: "About {{name}}",
  searchByVesselRegions: "Search by regions visited by {{name}}",
  searchByDescendingRegions: "Search by area in {{name}}",
  searchFromVesselsToRegion: "Search from vessels to {{name}}",
  regionCruiseListTitle: "Explore cruises by region",
  lpCruiseTitle: "Recommended Cruises",
  lpOverseasCruiseTitle: "Recommended Overseas Cruises",
};
